import { useEffect, useState } from 'react';
import { CacheProvider } from '@emotion/react';
// import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
// import Card from '@mui/material/Card';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
// import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
// import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { addDataPosition, appendStyleSheet, getEndpoint, getID, getMUICache, getUrl, fetchAnchorValue, isCSR, insertAdSlot } from '../../../common/utils';
//import { appendStyleSheet, getEndpoint, getID, getMUICache, getUrl } from './../../../common/utils';
import { I_CDSListingItemTO } from '@interfaces/ICDSListingResponseTO';
import "./BreakingNewsThree.css";
import { PAGEBUILDER_URLS } from '../../Common/Constant';
import ArrowForwardIosOutlinedIcon from '@mui/icons-material/ArrowForwardIosOutlined';
import ArrowBackIosNewOutlinedIcon from '@mui/icons-material/ArrowBackIosNewOutlined'
import { IconButton } from '@mui/material';
//import styles from '!!raw-loader!./BreakingnewsThree.css';
import bcrypt from 'bcryptjs-react';
// import { isMobile, isDesktop } from "react-device-detect";
import React from 'react';

BreakingNewsThree.version = 1000;

BreakingNewsThree.lang = 'en';
BreakingNewsThree.langs = [
  'en'
];
BreakingNewsThree.setLang = (lang: any) => {
  BreakingNewsThree.lang = lang;
}

Object.defineProperty(BreakingNewsThree, 'name', {
  writable: true,
  value: 'BreakingNewsThree'
});





const NextArrow = (props: any)=>{
  const { className, style, onClick } = props;
  return (
    <div className={className} style={{ ...style, display: "block", background: "#585858", color: "#fff", right: "0", zIndex: "5", width: "32px", height: "32px", borderRadius: "4px" }} onClick={onClick}>
     
      <IconButton className='CustomPrevArrow'>
        <ArrowForwardIosOutlinedIcon />
      </IconButton>
      
    </div>
  );
}

const PrevArrow = (props: any)=> {
  const { className, style, onClick } = props;
  return (
    <div className={className} style={{ ...style, display: "block", background: "#585858", color: "#fff", left: "0", zIndex: "5", width: "32px", height: "32px", borderRadius: "4px" }} onClick={onClick}>
      {/* <KeyboardArrowLeftIcon fontSize='medium' /> */}
      <IconButton className='CustomNextArrow'>
        <ArrowBackIosNewOutlinedIcon />
      </IconButton>
    </div>
  );
}

export function BreakingNewsThree(props: any) {

  const { anchorLinksValue } = props;

  let styles = require("./BreakingNewsThree.css");
  const [msid, setMsid] = useState<any>('');
  const [items, setItems] = useState<I_CDSListingItemTO[]>([]);
  appendStyleSheet("BreakingNewsThree", styles);

  // const [clientDevice, setClientDevice] = useState({ isDesktop: false, isMobile: false });
  // useEffect(() => {
  //   setClientDevice({ isDesktop, isMobile });
  // }, []);

 
  const endpoint = getEndpoint(props);
  useEffect(() => {
    if (!endpoint.isSSR || !endpoint.SSRDataObj) {
      fetchComponentData();
    }
  }, [props.MSID, endpoint, props.showAdSlot]);

  // useEffect(() => {
  //   if (clientDevice.isDesktop && props.bodyAdScript) {
  //       const adContainer = document.getElementById("ad-container");
  //       if (adContainer) {
  //           const script = document.createElement("script");
  //           script.async = true;
  //           script.innerHTML = props.bodyAdScript.match(/<script[^>]*>([\s\S]*?)<\/script>/)?.[1] || "";
  //           adContainer.appendChild(script);
  //       }
  //   }
  //   if (clientDevice.isMobile && props.bodyAdMobileScript) {
  //       const adContainer = document.getElementById("ad-container");
  //       if (adContainer) {
  //           const script = document.createElement("script");
  //           script.async = true;
  //           script.innerHTML = props.bodyAdMobileScript.match(/<script[^>]*>([\s\S]*?)<\/script>/)?.[1] || "";
  //           adContainer.appendChild(script);
  //       }
  //   }
  // }, [clientDevice.isDesktop,clientDevice.isMobile, props.bodyAdScript, props.bodyAdMobileScript]);

  useEffect(() => {
    if (typeof window !== 'undefined' && window.gpEditor) {

        window.gpEditor.editor.on('component:selected', (component: any) => {
            if (component && component.attributes && component.attributes.type === "Breaking News") {
                setTimeout(() => {
                    const trait = component.getTraits().find((tr: any) => tr.get('id') === "deviceType");
                    if (trait && trait.el) {
                        // Show trait element if showAdSlot is true, hide otherwise
                        trait.el.style.display = props.showAdSlot ? 'block' : 'none';
                    }
                }, 200);
            }
        });

        const selected = window.gpEditor.getSelected();
        if (selected) {
            const trait = selected.getTraits().find((tr: any) => tr.get('id') === "deviceType");
            if (trait && trait.el) {
                // Show trait element if showAdSlot is true, hide otherwise
                trait.el.style.display = props.showAdSlot ? 'block' : 'none';
            }
        }
    }
  }, [endpoint, props.showAdSlot, props.adSize]);


  const setItemsObj = (response: any) => {
    setItems(response?.items)
  }

  if (endpoint.isSSR && endpoint.SSRDataObj && (!items || !items.length) 
    && endpoint.SSRDataObj.items && endpoint.SSRDataObj.items.length != 0) {
    setItemsObj(endpoint.SSRDataObj);
  }

  const fetchComponentData = () => {
    getData(getUrl(props));
  }

  const getData = (url: string) => {
    let headerString = '?' + url.split("?")[1];
    headerString = bcrypt.hashSync(headerString, 6);
    const headers = {'p-nonce': headerString};

    fetch(url, { headers: headers })
      .then((response) => response.json())
      .then(response => {
        setItemsObj(response);
      })
      .catch(err => {
        //console.log(err);
      });
  }

  const carouselRef = React.useRef(null);

  const getRenderPart = () => {
    if (msid && props.msid && msid != props.msid) {
      props.queryParams.msid = props.msid;
      setMsid(props.queryParams.msid);
      getData(getUrl(props));
    }

    if (!items || !items.length) {
      return "";
    }

    // for (var i = 0; i < items.length; i++) {
    //   if (items[i].id === "") {
    //     const className = "mh-" + currentPageIndex + "_" + i + " listcontainer";
    //     const Id = "ad-list-" + currentPageIndex + "_" + i;
    //     listData.push(<div key={i} id={Id} className={className} dangerouslySetInnerHTML={{ __html: bodySnippet }}></div>)
    //   }
    // }
    let i_scrollMode = true;
    if (props.scroll == props.CONSTANTS.SCROLL_MODE.MANUAL) {
      i_scrollMode = false;
    }

    //let componentClasses = getClasses(props.data);
    let componentID = getID(props.data);

    let blockHeading: any = '';
    if (props.mainHeading) {
      blockHeading = <div className="ThemeThreeTrnHeadingWrap ThemeThreeTrandingNewsHeadingWrap">
        {/* <h3><Link href={props.mainHeadingHref} style={{ color: "#000" }} target="_self">{props.mainHeading}</Link></h3> */}
        <p className='ThemeThreeTrnHeading'><a style={{ color: props.mainHeadingColor }} href={props.mainHeadingHref}>{props.mainHeading}</a></p>
      </div>;
    }
//     <div className='ThemeTwoTrnHeadingWrap'>
//     <p className='ThemeTwoTrnHeading'>{blockHeading}</p>
// </div>
    const Carouselsettings = {
      infinite: true,
      speed: 500,
      autoplay: i_scrollMode,
      slidesToShow: 4,
      slidesToScroll: parseInt(props.scrollCount, 10),
      initialSlide: 0,
      nextArrow: <NextArrow />,
      prevArrow: <PrevArrow />,
      swipeToSlide: true,
      variableWidth: true,
      dots: true,
      arrows: true,
      className: 'ThemeThreeTreandingNews',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1,
            slidesToScroll: props.scrollCount,
            variableWidth: true,
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: props.scrollCount,
            variableWidth: true,
            arrows: false,
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,

          }
        }
      ]
    };

    let bodySnippet: any;
    if (isCSR() && PAGEBUILDER_URLS.some(url => window.location.origin.includes(url))) {
      bodySnippet = `<div className=\'breaking-news\' style="width: 259px;text-align: center;">Ad Slot<br>259 X 79</div>`
    } 
    else if (isCSR()) {
      console.log("Only CSR");
      // if (clientDevice.isDesktop) {
      //   bodySnippet = `<div id="ad-container">${props.bodyAdScript?.replace(/<script[^>]*>[\s\S]*?<\/script>/, "")}</div>`;
      // } else if (clientDevice.isMobile) {
        
      //   bodySnippet = `<div id="ad-container">${props.bodyAdMobileScript?.replace(/<script[^>]*>[\s\S]*?<\/script>/, "")}</div>`;
      // }
      bodySnippet = props?.data?.attributes?.adConfigurations;
    }
    else {
      console.log("Only SSR");
      // bodySnippet = `<div></div>`;
      bodySnippet = props?.data?.attributes?.adConfigurations;
    }

    return <CacheProvider value={getMUICache()}>
      
      <div id={componentID} className='breakingNewsTwoFullWrap' style={{backgroundColor:props.BGColor}}>
        <div className='breakingNewsTwoContainer'>
          <p className='i'>{blockHeading}</p>
        <div>
          <Slider {...Carouselsettings} ref={carouselRef}>
            {items &&
              items.map((itemObj, index) => {
                if (props.showAdSlot) {

                  if (isCSR() && PAGEBUILDER_URLS.some(url => window.location.origin.includes(url))) { 
                    if (props.adNetwork === "google" && index === 2) {
                      return <div key={'0_' + index} className='breaking-news' dangerouslySetInnerHTML={{ __html: addDataPosition(bodySnippet, index) }}></div>
                    } else if (props.adNetwork === "can") {
                      if ((index + 1) % 4 === 3) {
                        return <div key={'0_' + index} className='breaking-news' dangerouslySetInnerHTML={{ __html: addDataPosition(bodySnippet, index) }}></div>
                      }
                    }
                  }
                  else {
                    if (props.adNetwork === "google" && index === 2) {
                      return <div key={'0_' + index} className='breaking-news' >{insertAdSlot(index, bodySnippet, props.name)}</div>
                    } else if (props.adNetwork === "can") {
                      if ((index + 1) % 4 === 3) {
                        return <div key={'0_' + index} className='breaking-news' >{insertAdSlot(index, bodySnippet, props.name)}</div>
                      }
                    }
                  }

                }
                return  <div key={'Bnewsitem_' + index} className='ThemeTwoWebTrnCardWrapSlide'>
                    <div className='ThemeTwoWebTrnCardWrap'>
                      <div className='ThemeTwoWebTrnCardContentWrap' style={{backgroundColor:props.cardBGColor}}>
                        <p className='trnDiscription'><Link href={itemObj.wu} key={'2_' + index}  target={fetchAnchorValue(anchorLinksValue, itemObj.wu)} style={{color:props.cardContentColor}}>{itemObj.hl}</Link></p>
                        <p className='countingWraper'>{index+1}</p>
                      </div>
                    </div>
                  </div>
               
              }
              )}
          </Slider>
        </div>
        </div>
      </div>
    </CacheProvider>
  }


  return (
    <>
      {getRenderPart()}
    </>
  );

}
